<template lang="pug">
  .input-texto
    .input-texto__input
      input(
        type="text"
        v-model="valorInput"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @change="handleChange"
        v-bind="$attrs"
        :placeholder="isFocused ? placeholder : ''"
        :class="{ erro: mensagemErro }"
      )
      label(v-if="label" :class="{ active: isFocused || valorInput }") {{ label }}
    .input-texto__erro(v-if="mensagemErro") {{ mensagemErro }}
</template>

<script>
export default {
  name: 'InputTexto',
  props: {
    label: {
      type: String,
      default: ''
    },
    mensagemErro: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFocused: false
    }
  },
  computed: {
    valorInput: {
      get () {
        return this.value
      },
      set (newValue) {
        if (!this.lazy) {
          this.$emit('input', newValue)
        }
      }
    }
  },
  methods: {
    handleChange (event) {
      if (this.lazy) {
        this.$emit('input', event.target.value)
      }
    }
  }
}
</script>

<style scoped>
.input-texto {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.input-texto__input {
  position: relative;
}
.input-texto__input input {
  width: 100%;
  padding: 20px 0 5px 0;
  border: none;
  border-bottom: 1px solid #c4c4c4;
  font-size: 1rem;
  outline: none;
  background: transparent;
}
.input-texto__input input.erro {
  border-bottom: 1px solid var(--color-danger);
  color: var(--color-danger);
}
.input-texto__input label {
  position: absolute;
  bottom: 5px;
  left: 0;
  font-size: 1rem;
  color:  #2C3E50;
  pointer-events: none;
  transition: all 0.2s ease;
}
.input-texto__input label.active {
  bottom: 30px;
  font-size: 90%;
}

.input-texto__erro {
  position: absolute;
  top: 50px;
  color: var(--color-danger);
  font-size: 0.75rem;
}
</style>
